import React, { useMemo, useRef, useState } from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import DownArrowColor from "../../assets/images/icons/down-arrow-color.svg"
import UpArrowColor from "../../assets/images/icons/up-arrow-color.svg"
import users from "../../assets/images/icons/users.svg"
import bag from "../../assets/images/icons/bag.svg"
import conversion from "../../assets/images/icons/conversion-rate.svg"
import investor from "../../assets/images/icons/investor.svg"
import user from "../../assets/images/icons/user.svg"
import wallet from "../../assets/images/icons/wallet.svg"
import file from "../../assets/images/icons/file-type.svg"
import check from "../../assets/images/icons/right-check.svg"
import documentfile from "../../assets/images/icons/document.svg"
import toast from "react-hot-toast"
import TableContainer from "components/Common/TableContainer"
import arrowDown from "../../assets/images/icons/arrow-down.svg"
import eye from "../../assets/images/icons/eye.svg"
import { addSpaceEveryNChars, checkExtension } from "helpers/common"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import moment from "moment"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}
const IndividualView = ({ partnerData }) => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "Investor Details  | Prachay"

  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([
    {
      category: "ICD",
      InvestedAmount: "₹25,00,000",
      UnitsHeld: "250",
      LastDate: "2025-04-20",
      SettlementDate: "2025-04-25",
    },
    {
      category: "REIT",
      InvestedAmount: "₹37,50,000",
      UnitsHeld: "150",
      LastDate: "2025-03-05",
      SettlementDate: "2025-03-10",
    },
    {
      category: "Unlisted Bonds",
      InvestedAmount: "₹25,00,000",
      UnitsHeld: "350",
      LastDate: "2025-04-20",
      SettlementDate: "2025-04-25",
    },
  ])

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/investor")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        horizontalformik.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <div>
            <div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Name</Label>
                  <Input
                    disabled
                    name="name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Date of Birth</Label>
                  <Input
                    disabled
                    name="name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.dob}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">PAN</Label>
                  <Input
                    disabled
                    name="name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsPAN?.pan}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Aadhaar No.</Label>
                  <Input
                    disabled
                    name="name"
                    type="text"
                    className="form-control"
                    value={addSpaceEveryNChars(
                      partnerData?.investorsAadhaar?.aadhaar_no
                    )}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Phone No.</Label>
                  <Input
                    disabled
                    name="phone"
                    type="text"
                    className="form-control"
                    value={partnerData?.phone}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Email Address</Label>
                  <Input
                    disabled
                    name="email"
                    type="text"
                    className="form-control"
                    value={partnerData?.email}
                  />
                </Col>

                <Col xl={6}>
                  <Label className="col-form-label">Primary Address</Label>
                  <Input
                    disabled
                    name="email"
                    type="textarea"
                    className="form-control"
                    value={partnerData?.additionalDetails?.primary_address}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Secondary Address</Label>
                  <Input
                    disabled
                    name="email"
                    type="textarea"
                    className="form-control"
                    value={partnerData?.additionalDetails?.secondary_address}
                  />
                </Col>

                {/* {partnerData?.additionalDetails?.business_trade_name && ( */}
                <>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Trade Name of the Business
                    </Label>

                    <Input
                      disabled
                      name="phone"
                      type="text"
                      className="form-control"
                      value={
                        partnerData?.additionalDetails?.business_trade_name ||
                        "Not Applicable"
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">GSTIN</Label>

                    <Input
                      disabled
                      name="phone"
                      type="text"
                      className="form-control"
                      value={
                        partnerData?.additionalDetails?.gstin ||
                        "Not Applicable"
                      }
                    />
                  </Col>
                </>
                {/* // )} */}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <div>
            <div>
              <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                <CardTitle className="">Bank Details</CardTitle>
              </div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Account Holders Name</Label>
                  <Input
                    disabled
                    name="account_holder"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_holder}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Number</Label>
                  <Input
                    disabled
                    name="account_no"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_no}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Bank Name</Label>
                  <Input
                    disabled
                    name="bank_name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.bank_name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">IFSC</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.ifsc}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Type</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_type}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <CardTitle className="mt-4 mb-4">Documents</CardTitle>

          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            KYC Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsAadhaar?.aadhaar_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsAadhaar.aadhaar_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Aadhaar</p>
                    <Link
                      to={partnerData?.investorsAadhaar.aadhaar_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                  <p></p>
                </div>
                {/* <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div> */}
              </div>
            )}
            {/* {partnerData?.avatar_url && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.avatar_url) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Selfie</p>
                    <Link to={partnerData?.avatar_url} target="_blank">
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                  <p></p>
                </div>
              </div>
            )} */}
            {partnerData?.investorsPAN?.pan_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.investorsPAN?.pan_file_url) ===
                  "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>PAN</p>
                    <Link
                      to={partnerData?.investorsPAN?.pan_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                  <p></p>
                </div>
                {/* <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div> */}
              </div>
            )}
            {/* {partnerData?.avatar_url && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.avatar_url) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Selfie</p>
                    <Link to={partnerData?.avatar_url} target="_blank">
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                  <p></p>
                </div>
              </div>
            )} */}

            {partnerData?.additionalDetails?.gst_certificate && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.additionalDetails?.gst_certificate_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>GST Certificate</p>
                    <Link
                      to={partnerData?.additionalDetails?.gst_certificate_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>

          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Banking Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsBankDetails?.cheque_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsBankDetails.cheque_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Cheque</p>
                    <Link
                      to={partnerData?.investorsBankDetails.cheque_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                  <p></p>
                </div>
                {/* <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div> */}
              </div>
            )}
          </div>

          {partnerData?.icdAgreements.length > 0 &&
            partnerData?.status === "APPROVED" && (
              <>
                <hr className="my-4" />
                <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                  Executed Documents
                </CardTitle>
                <div className="documents-section">
                  {partnerData?.icdAgreements.filter(doc => doc.status === 'SUCCESS').map((doc, index) => (
                    <div className="documents-box" key={`docs_${index}`}>
                      <div className="file-type">
                        <img src={pdfIcon} alt="" />

                        <div>
                          <p>
                            {doc.doc_type === "TERM_SHEET"
                              ? `ICD Schedule Terms_${moment(doc.created_at).format("DD.MM.YYYY")}`
                              : `Wealth Partner Agreement_${moment(doc.created_at).format("DD.MM.YYYY")}`}
                          </p>
                          <Link to={doc.doc_url} target="_blank">
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                              <img src={check} alt="" /> Verified
                            </div> */}
                    </div>
                  ))}
                </div>
              </>
            )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default IndividualView
